import Cookies from "js-cookie";
import { persistor } from "../redux/store";
import { clearReturnUrl } from "./returnUrl";

// Ends the backoffice session and returns to the project's login page.
export const logoutBackoffice = () => {
  persistor.purge();
  Cookies.remove(`mhet_mst_token`);
  Cookies.remove(`mhet_mst_userid`);
  clearReturnUrl();
  sessionStorage.removeItem("selectedCourseId");
  sessionStorage.removeItem("selectedQuestion");
  window.location.href = `/${Cookies.get("mhet_mst_project")}/`;
};
